import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { CheckboxModule } from 'primeng/checkbox';
import { FormsModule } from '@angular/forms';
import { PDF_EXPORT_ACTIONS } from '../../../../store/actions/pdf-export.actions';
import { Store } from '@ngrx/store';

export enum EPdfContentType {
  transcript = 'transcript',
  details = 'details',
  scorecards = 'scorecards',
}

@Component({
  selector: 'cv-pdf-content-selection-dialog',
  standalone: true,
  imports: [ButtonModule, DialogModule, CheckboxModule, FormsModule],
  templateUrl: './pdf-content-selection-dialog.component.html',
  styleUrls: ['./pdf-content-selection-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class PdfContentSelectionDialogComponent {
  @Input() isVisible: boolean = false;
  @Output() readonly closeDialog = new EventEmitter<void>();

  readonly contentOptions = [
    { label: 'Transcript', value: EPdfContentType.transcript },
    { label: 'Conversation Details', value: EPdfContentType.details },
    { label: 'Scorecards', value: EPdfContentType.scorecards },
  ];
  selectedContent: EPdfContentType[] = this.contentOptions.map(({ value }) => value);

  constructor(private readonly store: Store) {}

  onDownload(): void {
    this.closeDialog.emit();
    this.store.dispatch(PDF_EXPORT_ACTIONS.export({ selectedContent: this.selectedContent }));
  }
}
